module.exports = {
      id: "login-facebook-usage",
      viewBox: "0 0 52.573 52.573",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#login-facebook",
      toString: function () {
        return this.url;
      }
    }